import { useQuery } from '@tanstack/react-query';
import useGlynt from './useGlynt';

export function usePage(url: string) {
  const glynt = useGlynt();

  return useQuery({
    queryKey: ['page', url],

    queryFn: async () => {
      return (await glynt).document.getPage(url);
    },

    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60
  });
}
